import { tw } from 'twind';

import { useSiteConfig } from 'hooks/useSiteConfig';
import { useTranslate } from 'hooks/useTranslations';
import { Variant } from '__generated__/graphql';
import { useGA4Events } from 'hooks/useGA4Events';

import { ResponsiveProductImage } from './ResponsiveProductImage';

export const ProductListItemImages = (props: {
  variant: Variant;
  dataTestId?: string;
  position?: number;
}) => {
  const t = useTranslate();
  const { fireClickProductImage } = useGA4Events();
  const {
    staticFeatures: { useVerticalMedia },
  } = useSiteConfig();

  const isOneOfTopProducts = Number(props?.position) <= 4;
  const { orderable, displayOutOfStock } = props.variant;
  const outOfStock = Boolean(!orderable || displayOutOfStock);

  // Only show the first image
  const firstImage =
    props.variant.images && props.variant.images.length > 0
      ? props.variant.images[0]
      : null;

  return (
    <div className="relative group" data-test-id={props.dataTestId}>
      <div className="flex">
        {firstImage && (
          <div key={firstImage.href} className="w-full flex-none transform-gpu">
            <ResponsiveProductImage
              src={
                useVerticalMedia
                  ? firstImage.verticalImageHref || firstImage.href
                  : firstImage.href
              }
              widths={[300, 350, 400, 450, 500, 550, 600]}
              sizes={{
                mobile: '50vw',
                tablet: '33vw',
                desktop: '25vw',
              }}
              width={400}
              alt={firstImage.alt}
              title={firstImage.alt}
              isVertical={useVerticalMedia}
              className={tw(outOfStock && 'opacity-50')}
              onClick={() => fireClickProductImage(firstImage.href)}
              loading={isOneOfTopProducts ? 'eager' : 'lazy'}
            />
          </div>
        )}
      </div>
      {outOfStock && (
        <span
          data-test-id="product-list-item-badge"
          className="absolute bottom-5 left-0 uppercase text-xs font-bold bg-white px-2 py-0.5 border-puma-black border-l-2"
        >
          {/* TODO: i18n the display value. */}
          {displayOutOfStock?.displayValue || t('soldOut')}
        </span>
      )}
    </div>
  );
};
